import { defineMessages } from 'react-intl';

export const messages: {
	ariaReorderLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	reorderLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	reorderLabel: {
		id: 'navigation.ribbon.reorder-toggle.label',
		description: 'Label for the reorder toggle in the navigation ribbon.',
		defaultMessage: 'Re-order',
	},
	ariaReorderLabel: {
		id: 'navigation.ribbon.reorder-toggle.arial-label',
		description: 'Aria label for the reorder toggle in the navigation ribbon.',
		defaultMessage: 'Re-order apps in the app rail',
	},
});
